import React from 'react';

const CFG = {
  critical: { bg:'var(--red-dim)',    border:'rgba(239,68,68,0.35)',  color:'var(--red)',    icon:'🔴', label:'KRİTİK' },
  warning:  { bg:'var(--yellow-dim)', border:'rgba(245,158,11,0.35)', color:'var(--yellow)', icon:'🟡', label:'UYARI'  },
  info:     { bg:'var(--accent-dim)', border:'rgba(59,130,246,0.35)', color:'var(--accent2)',icon:'🔵', label:'BİLGİ'  },
};

const TYPE_LABELS = {
  device_offline:   'Bağlantı Kesildi',
  long_inactivity:  'Uzun Süredir Aktivite Yok',
  low_activity:     'Düşük Aktivite',
  anomaly_drop:     'Anormal Düşüş',
  recovery:         'Bağlantı Yeniden Kuruldu',
};

export default function AlertsPanel({ alarms = [], loading = false, compact = false, showEmpty = true }) {
  if (loading) return (
    <div style={{ padding:'14px 18px', background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--r-sm)', display:'flex', alignItems:'center', gap:10, color:'var(--text3)', fontSize:13 }}>
      <span className="spinner" style={{ width:14, height:14 }} /> Alarmlar kontrol ediliyor...
    </div>
  );

  if (!alarms.length) {
    if (!showEmpty) return null;
    return (
      <div style={{ display:'flex', alignItems:'center', gap:10, padding: compact?'10px 16px':'14px 18px', background:'var(--green-dim)', border:'1px solid rgba(34,197,94,0.35)', borderRadius:'var(--r-sm)', color:'var(--green)' }}>
        <span>🟢</span>
        <span style={{ fontWeight:600, fontSize:13 }}>Sistem Normal — Aktif alarm yok</span>
      </div>
    );
  }

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
      {alarms.map((alarm, i) => {
        const cfg = CFG[alarm.level] || CFG.info;
        return (
          <div key={alarm.id || i} style={{ background:cfg.bg, border:`1px solid ${cfg.border}`, borderRadius:'var(--r-sm)', padding: compact?'8px 14px':'12px 16px', display:'flex', alignItems:'flex-start', gap:10 }}>
            <span style={{ fontSize: compact?14:16, flexShrink:0, marginTop:1 }}>{cfg.icon}</span>
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
                <span style={{ fontSize: compact?12:13, fontWeight:700, color:cfg.color }}>
                  {TYPE_LABELS[alarm.type] || alarm.type}
                </span>
                {alarm.device_key && (
                  <code style={{ fontSize:11, background:'rgba(0,0,0,0.15)', padding:'1px 6px', borderRadius:3, color:cfg.color }}>
                    {alarm.device_key}
                  </code>
                )}
              </div>
              <div style={{ fontSize: compact?12:13, color:'var(--text2)', marginTop:2 }}>{alarm.message}</div>
              {!compact && (
                <div style={{ display:'flex', gap:16, marginTop:4, flexWrap:'wrap' }}>
                  {alarm.minutes_offline !== null && alarm.minutes_offline !== undefined && (
                    <span style={{ fontSize:11, color:'var(--text3)' }}>
                      Offline: {alarm.minutes_offline} dk
                    </span>
                  )}
                  {alarm.last_seen && (
                    <span style={{ fontSize:11, color:'var(--text3)' }}>
                      Son görülme: {new Date(alarm.last_seen).toLocaleString('tr-TR')}
                    </span>
                  )}
                  {alarm.last_event_time && (
                    <span style={{ fontSize:11, color:'var(--text3)' }}>
                      Son veri: {new Date(alarm.last_event_time).toLocaleString('tr-TR')}
                    </span>
                  )}
                </div>
              )}
            </div>
            <span style={{ fontSize:9, color:cfg.color, fontWeight:800, letterSpacing:'0.06em', flexShrink:0, marginTop:2 }}>
              {cfg.label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
